/**
 * Created by lobin on 2018/9/3.
 */
export default {
	text:[
		{ required: true, message: '不能为空'}
	],
	array:[
		{ required: true, message: '不能为空', type: 'array',trigger: 'change' }
	]
}